import { Consultant } from '@/types';
import { Form, Flex, Button, Typography } from 'antd';
import { useParams, useNavigate } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';
import { ConsultantCreate } from '@/components/admin/create/ConsultantCreate';

const CreateDetailsPageConsultant = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm<Partial<Consultant>>();

  const onBack = () => {
    navigate(`/control-panel/consultants`);
  };

  const onCancel = () => {
    navigate(`/control-panel/consultants`);
  };
  return (
    <>
      <Flex justify="start" align="start" gap={8} vertical>
        <Button
          type="link"
          icon={<LeftOutlined />}
          onClick={onBack}
          style={{ color: '#22252D', fontWeight: 500, paddingLeft: 0 }}
        >
          Back
        </Button>
        <Typography.Title
          level={3}
          style={{
            margin: '0 0 24px',
          }}
        >
          Create User
        </Typography.Title>
      </Flex>
      <ConsultantCreate form={form} onCancel={onCancel} />
    </>
  );
};

export default CreateDetailsPageConsultant;
